export default __webpack_public_path__ + "static/media/fun_jun2020_pt3.792253aa.bmp";